exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.filters[data-v-67382020] {\n  height: 7vh;\n  border-bottom: 1px solid #DBDFE2;\n}\n.filters .v-select.searchable input[type=\"search\"][data-v-67382020] {\n    font-size: 0.8rem;\n    line-height: 1.4rem;\n    height: 1.4rem;\n    padding: 0 2rem 0 0.75rem;\n}\n.filters .v-select.searchable .dropdown-toggle[data-v-67382020] {\n    height: 34px;\n}\n.filters .v-select.searchable .open-indicator[data-v-67382020] {\n    bottom: 0;\n}\n.filters .type-filters .dropdown[data-v-67382020] {\n    margin-right: 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-67382020","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/Filters.vue
// module id = 2677
// module chunks = 0